module.exports = __webpack_public_path__ + "img/collection-weddingRingsFrameSettings@2x.31add94.jpg";